module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-ExtraBold-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-ExtraBold-webfont.woff
// module id = 378
// module chunks = 0